import semver from 'semver';

type TClickAndRevealDefaultStyles = {
  includePanelBackground: boolean;
  panelBackgroundOpacity: number;
  backgroundColor: string;
  clickAndRevealPanelTextColor: string;
  includeLabel: boolean;
  clickAndRevealLabelTextColor: string;
  showSeenState: boolean;
  clickAndRevealShowSeenStateBackgroundColor: string;
  clickAndRevealShowSeenStateTickColor: string;
  width: number;
  height: number;
  panelOutline: boolean;
  panelOutlineColor: string;
  borderRadius: number;
  focusColor: string;
  layout:
    | 'One column reversed'
    | 'Two column reversed'
    | 'One column'
    | 'Two column';
  useGlobalNavigation: boolean;
  globalNavigation: {};
  includeShadow: boolean;
};

export const clickAndRevealDefaultStyles: {
  [key: string]: TClickAndRevealDefaultStyles;
} = {
  base: {
    includePanelBackground: true,
    panelBackgroundOpacity: 100,
    backgroundColor: '#ffffff',
    clickAndRevealPanelTextColor: '#282A2B',
    includeLabel: true,
    clickAndRevealLabelTextColor: '#282A2B',
    showSeenState: true,
    clickAndRevealShowSeenStateBackgroundColor: '#282A2B',
    clickAndRevealShowSeenStateTickColor: '#ffffff',
    width: 260,
    height: 210,
    panelOutline: false,
    panelOutlineColor: '#ffffff',
    borderRadius: 10,
    // borderColor,
    focusColor: '#ffffff',
    layout: 'One column reversed',
    useGlobalNavigation: false,
    globalNavigation: {},
    includeShadow: false,
  },
  '1.5.0': {
    includePanelBackground: true,
    panelBackgroundOpacity: 100,
    backgroundColor: '#ffffff',
    clickAndRevealPanelTextColor: '#282A2B',
    includeLabel: true,
    clickAndRevealLabelTextColor: '#282A2B',
    showSeenState: true,
    clickAndRevealShowSeenStateBackgroundColor: '#282A2B',
    clickAndRevealShowSeenStateTickColor: '#ffffff',
    width: 260,
    height: 210,
    panelOutline: false,
    panelOutlineColor: '#ffffff',
    borderRadius: 10,
    // borderColor,
    focusColor: '#ffffff',
    layout: 'One column reversed',
    useGlobalNavigation: false,
    globalNavigation: {},
    includeShadow: true,
  },
};

export const getDefaultStyles = (blockMetaPackageVersion: string = '') => {
  if (!blockMetaPackageVersion || !semver.valid(blockMetaPackageVersion)) {
    return clickAndRevealDefaultStyles['base'];
  }

  if (semver.gte(blockMetaPackageVersion, '1.5.0')) {
    return clickAndRevealDefaultStyles['1.5.0'];
  }
  //

  return clickAndRevealDefaultStyles['base'];
};
